import { MRT_ColumnDef } from 'material-react-table';
import NameCellWithImage, { ChipCell } from 'components/controls/image-cell';
import { useWorkspace } from 'hooks/useWorkspace';
import { TERMINAL_STATUS_COLOR } from 'features/terminal/constants/status';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { ToolTip } from 'components/controls';

export type PlacesColumns = {
    id: string;
    name: string;
    websiteId: string;
    terminalId: string;
    createdAt: string;
    street: string;
    streetNumber: string;
    zipCode: string;
    city: string;
    country: string;
    websiteName: string;
    terminalStatus: string;
    terminalName: string;
    logo: string;
};

export const usePlaceTableColumns = (): MRT_ColumnDef<PlacesColumns>[] => {
    const { t } = useTranslation();
    const { baseWorkspaceUrl } = useWorkspace();

    return useMemo(
        () => [
            {
                accessorKey: 'name',
                header: t('TABLE_HEADERS.NAME'),
                Cell: ({ cell }) => {
                    const id = cell.row.original.id;
                    const path = `${baseWorkspaceUrl}/place/${id}`;
                    console.log(cell.row.original['name']?.length);

                    return (
                        <ToolTip
                            disableHoverListener={cell.row.original['name'].length < 45}
                            title={cell.getValue<string>()}
                            placement="top-end"
                        >
                            <NameCellWithImage cell={cell} isLink path={path} target="_self" />
                        </ToolTip>
                    );
                },
                enableColumnActions: false,
                size: 300,
            },
            {
                id: 'address',
                header: t('TABLE_HEADERS.ADDRESS'),
                accessorFn: (row) => `${row.street} ${row.streetNumber}`,
                enableColumnActions: false,
                enableSorting: false,
                enableColumnFilter: false,
                size: 150,
            },
            {
                id: 'cityId',
                accessorKey: 'cityName',
                header: t('TABLE_HEADERS.CITY'),
                filterVariant: 'autocomplete',
                enableColumnActions: false,
                enableSorting: false,
                size: 100,
            },
            {
                id: 'terminalId',
                accessorKey: 'terminalName',
                header: t('TABLE_HEADERS.TERMINAL'),
                filterVariant: 'autocomplete' as const,
                enableColumnActions: false,
                enableSorting: false,
                size: 150,
            },
            {
                accessorKey: 'terminalStatus',
                header: t('TABLE_HEADERS.STATUS'),
                enableColumnActions: false,
                enableColumnFilter: false,
                enableSorting: false,
                size: 150,
                Cell: ({ cell }) => (
                    <ChipCell
                        value={cell.getValue<string>()}
                        statusColorMap={TERMINAL_STATUS_COLOR}
                        translationKey="STATUS"
                    />
                ),
            },
            {
                accessorKey: 'createdAt',
                header: t('TABLE_HEADERS.CREATION_DATE'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 100,
            },
        ],
        [t, baseWorkspaceUrl],
    );
};
